import { Search } from 'components';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as Ui from './ProductSearch.styles';

const ProductSearch = React.memo(
  ({ setSearch, showFavoritesOnly, onToggleFavoriteFilter, onResetFavoriteFilter }) => {
    const [inputValue, setInputValue] = useState('');

    const { t: tApp } = useTranslation('app');
    const { t } = useTranslation('ownerPortal');

    const debouncedSetSearchQuery = useMemo(
      () => debounce((value) => setSearch(value), 400),
      [setSearch],
    );

    const hasActiveFilters = Boolean(inputValue) || showFavoritesOnly;

    const resetFields = () => {
      debouncedSetSearchQuery.cancel();
      setInputValue('');
      setSearch('');
      onResetFavoriteFilter();
    };

    const handleSearchChange = (value) => {
      setInputValue(value);
      debouncedSetSearchQuery(value);
    };

    useEffect(() => () => debouncedSetSearchQuery.cancel(), [debouncedSetSearchQuery]);

    return (
      <Ui.ProductSearchWrapper>
        <Ui.WrapperAutocomplete>
          <Search
            value={inputValue}
            onChange={handleSearchChange}
            placeholder={t('favouriteProducts.searchPlaceholder')}
          />
        </Ui.WrapperAutocomplete>
        <Ui.FilterButton type="button" $active={showFavoritesOnly} onClick={onToggleFavoriteFilter}>
          Favorite
        </Ui.FilterButton>
        <Ui.ClearButton
          as={Button}
          type="reset"
          size="sm"
          variant="primary"
          disabled={!hasActiveFilters}
          onClick={resetFields}
        >
          {tApp('clear').toUpperCase()}
        </Ui.ClearButton>
      </Ui.ProductSearchWrapper>
    );
  },
);

ProductSearch.propTypes = {
  setSearch: PropTypes.func.isRequired,
  showFavoritesOnly: PropTypes.bool,
  onToggleFavoriteFilter: PropTypes.func.isRequired,
  onResetFavoriteFilter: PropTypes.func.isRequired,
};

ProductSearch.defaultProps = {
  showFavoritesOnly: false,
};

export default ProductSearch;
